/**
 * @type {{leadScore : 'Likely'| 'High'| 'Low' | 'Medium'}[]}
 */
export default [
	{ leadScore: 'Likely' },
	{ leadScore: 'High' },
	{ leadScore: 'Medium' },
	{ leadScore: 'Medium' },
	{ leadScore: 'Medium' },
	{ leadScore: 'Medium' },
	{ leadScore: 'Low' },
];
